package com.essntl.features.country.data.supabase

import com.essntl.core.utils.utils.capitalise
import com.essntl.features.country.domain.model.CountryModel
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CountryDto(
    val id: String,
    val name: String,
    @SerialName("created_at")
    val createdAt: String,
) {
    fun toModel() =
        CountryModel(
            id = id,
            name = name.lowercase().capitalise(),
            createdAt = createdAt,
        )
}
